import React, { createContext, useContext, useEffect, useState } from 'react';
import { collection, onSnapshot, query, db } from '../firebase';
import { Store } from '../types';

interface StoreContextType {
    stores: Store[];
    loading: boolean;
}

const StoreContext = createContext<StoreContextType>({ stores: [], loading: true });

export const useStores = () => useContext(StoreContext);

export const StoreProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [stores, setStores] = useState<Store[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const q = query(collection(db, 'stores'));
        const unsubscribe = onSnapshot(q, (snapshot) => {
            const fetchedStores = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() } as unknown as Store));
            setStores(fetchedStores);
            setLoading(false);
        }, (error) => {
            console.error("Error fetching stores:", error);
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    return (
        <StoreContext.Provider value={{ stores, loading }}>
            {children}
        </StoreContext.Provider>
    );
};
